import { ExperienceCategory } from '@/generated/graphql';
import Image from 'next/image';
import { ComponentProps } from 'react';
import AdvocateIcon from '../assets/advocate-default.png';
import AdvocateConstellation from '../assets/advocate-hover.png';
import ConnectIcon from '../assets/connect-default.png';
import ConnectConstellation from '../assets/connect-hover.png';
import ExploreIcon from '../assets/explore-default.png';
import ExploreConstellation from '../assets/explore-hover.png';
import MakeIcon from '../assets/make-default.png';
import MakeConstellation from '../assets/make-hover.png';
import MoveIcon from '../assets/move-default.png';
import MoveConstellation from '../assets/move-hover.png';
import TasteIcon from '../assets/taste-default.png';
import TasteConstellation from '../assets/taste-hover.png';

export interface CategoryContent {
  text: string;
  category: ExperienceCategory;
  icon: ComponentProps<typeof Image>;
  constellation: ComponentProps<typeof Image>;
  textOffset: {
    top: number;
    left: number;
  };
}

export function getCategoriesContent() {
  const icons: CategoryContent[] = [
    {
      text: 'Taste',
      category: ExperienceCategory.Taste,
      icon: {
        src: TasteIcon,
        alt: 'Taste Icon',
      },
      constellation: {
        src: TasteConstellation,
        alt: 'Taste Icon',
      },
      textOffset: {
        top: 60,
        left: 60,
      },
    },
    {
      text: 'Make',
      category: ExperienceCategory.Make,
      icon: {
        src: MakeIcon,
        alt: 'Make Icon',
      },
      constellation: {
        src: MakeConstellation,
        alt: 'Make Icon',
      },
      textOffset: {
        top: 15,
        left: 15,
      },
    },
    {
      text: 'Move',
      category: ExperienceCategory.Move,
      icon: {
        src: MoveIcon,
        alt: 'Move Icon',
      },
      constellation: {
        src: MoveConstellation,
        alt: 'Move Icon',
      },
      textOffset: {
        top: 70,
        left: 10,
      },
    },
    {
      text: 'Connect',
      category: ExperienceCategory.Connect,
      icon: {
        src: ConnectIcon,
        alt: 'Connect Icon',
      },
      constellation: {
        src: ConnectConstellation,
        alt: 'Connect Icon',
      },
      textOffset: {
        top: 80,
        left: 45,
      },
    },
    {
      text: 'Explore',
      category: ExperienceCategory.Explore,
      icon: {
        src: ExploreIcon,
        alt: 'Explore Icon',
      },
      constellation: {
        src: ExploreConstellation,
        alt: 'Explore Icon',
      },
      textOffset: {
        top: 10,
        left: 10,
      },
    },
    {
      text: 'Advocate',
      category: ExperienceCategory.Advocate,
      icon: {
        src: AdvocateIcon,
        alt: 'Advocate Icon',
      },
      constellation: {
        src: AdvocateConstellation,
        alt: 'Advocate Icon',
      },
      textOffset: {
        top: 70,
        left: 28,
      },
    },
  ];

  return icons;
}
